(function () {
  // Make sure Transcend + airgap exist
  if (typeof window.transcend !== 'object' || typeof window.transcend.showConsentManager !== 'function') {
    return;
  }
  if (typeof window.airgap !== 'object' || typeof window.airgap.getRegimes !== 'function') {
    return;
  }

  // Only show button for DoNotSell regime
  if (!airgap.getRegimes().has('DoNotSell')) {
    return;
  }

  var cpraButton = document.getElementById('cpra_button');
  if (!cpraButton) return;

  // Make it visible
  cpraButton.style.display = 'inline-flex';

  // On click → open consent manager
  cpraButton.addEventListener('click', function (event) {
    event.preventDefault();
    transcend
      .showConsentManager({ viewState: 'CompleteOptions' })
      .catch(function (err) {
        console.warn('showConsentManager error:', err);
      });
  });
})();
